import React, { Fragment, useState, useEffect, lazy, Suspense } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Alert, Modal } from '@walmart-web/livingdesign-components'

import SelectedSiteToStore from '../../components/ProductDetailPage/SelectedSiteToStore'
import ImagePreview from '../ImagePreview'

import AddToCart from '../../components/ProductDetailPage/components/AddToCart'
import ButtonGroup from '../../components/ProductDetailPage/components/ButtonGroup'
import BrandLink from '../../components/ProductDetailPage/components/BrandLink'
import ProductDetailDisplayName from '../../components/ProductDetailPage/components/ProductDetailDisplayName'
import SecondSiteToStoreComponent from '../../components/ProductDetailPage/components/SecondSiteToStoreComponent'
import RetractModal from '../../components/RetractModal/Index'

import ProductVariant from './components/ProductVariant'

import CombinableProducts from '../../functional-components/CombinableProducts'

import SiteToStoreTitle from './components/SiteToStoreTitle'

import { getDiscountBase, getColorForUnits, isProductAvailableToSell } from '../../components/ProductDetailPage/utils'

import RctCard from '../../components/RctCards/RctCard'

import { getMaxSalesUnitsForProduct, isProductPack } from '../../Helpers'
import texts from '../../common/texts.json'

import useShoppingCart from '../ShoppingCart/hooks/useShoppingCart'
import ProductPrices from '../ProductPrices'
import CompleteProductPack from '../CompleteProductPack'

import useWindowSize from '../../hooks/useWindowSize'
import NewMobileAddToCartButtonPdp, {
  NewMobileAddToCartButtonPdpFirst,
} from '../../experiments/new-mobile-add-to-cart-button-pdp/index'
import FeatureOnModalButton from '../../functional-components/FeatureOnModalButton'
import textTemplate from '../../common/textTemplate'
import { ORIGINS } from '../../common/GoogleTagManager'
import InlineRating from '../../components/RatingsReviews/InlineRating'
import constants from '../../common/constants'
import WfsDisclaimer from '../WfsDisclaimer'
import ProductSeller from '../ProductSeller'
import InternationalSeller from '../InternationalSeller'
import BuyboxMoreSellerOptions from '../BuyboxMoreSellerOptions'
import DeliveryOptionButton from './components/DeliveryOptionButton'
import PickUpStoresModal from './components/PickUpStoresModal'
import getConfig from '../../Helpers/getConfig'
import BannerLiderPLP_PDP from '../../components/BannerLiderPLP_PDP'
import './index.css'
import { Link } from 'react-router-dom'

const BuyboxSellerOptions = lazy(() => import('../BuyboxSellerOptions'))
const ProductDetailCard = ({
  hit,
  campaignConfig,
  origin,
  pickupStore,
  selectedWalstoreStore,
  isWalstore,
  restrictShoppingCart,
  isSod,
  flowType,
  updateProduct,
  plpPosition,
  searchState,
  bannersPDP,
}) => {
  const { handleAddToCart, handleRemoveOneFromCart, getProductQuantityInCart } = useShoppingCart()
  const { isMobile } = useWindowSize()
  const [isMandatoryVariantSelected, setIsMandatoryVariantSelected] = useState(false)
  const [shouldRenderVariantMessage, setShouldRenderVariantMessage] = useState(false)
  const [showWfsDisclaimerModal, setShowWfsDisclaimerModal] = useState(false)
  const [showBuyboxSellerOptionsModal, setShowBuyboxSellerOptionsModal] = useState(false)
  const [pickUpStoresModalIsOpen, setPickUpStoresModalIsOpen] = useState(false)
  const [pickUpStoresSpinner, setPickUpStoresSpinner] = useState(false)
  const [retractOpen, setRetractOpen] = useState(false)

  const listProduct = campaignConfig.groceryBoxSets ? campaignConfig.groceryBoxSets : []
  const {
    brand,
    displayName,
    itemNumber,
    makePublic,
    isMKP = false,
    winningOffer,
    tags = {},
    wfsEligible = false,
    rankedOffers = [],
    attributes = {},
  } = hit
  const isFacetKeysFromPdpEnabled = campaignConfig?.enablePdpFacetKeys
  const { brand: brandKeyFacet, seller: sellerKeyFacet } = campaignConfig.pdpFacetKeys || {}

  const productQuantity = getProductQuantityInCart(hit)
  const discount = getDiscountBase(hit)
  const newItem = Object.assign({}, hit, { quantity: productQuantity })
  const maxUnits = getMaxSalesUnitsForProduct(listProduct, newItem)
  const isXxYPromotion = (isSod || campaignConfig?.promotions?.enabledCatexXxYPack) && isProductPack(hit.price)

  const { SITE_TO_STORE } = constants.DELIVERY_TAG_KEYS
  const { deliveryTags = [] } = tags
  const showSiteToStoreLabel = deliveryTags.includes(SITE_TO_STORE)

  const hasVariants = !!(hit.variants && Object.keys(hit.variants).length >= 1)
  const hasValidVariants = !!(hasVariants && hit.attributes.skuColor && hit.attributes.skuSize)
  const isCombinableProduct = hit?.promotion?.isCombinable && isProductPack(hit.price)
  const { soldByWeight = 'false' } = attributes

  // when product is in cart, variants should be selected
  useEffect(() => {
    if (productQuantity > 0) {
      setIsMandatoryVariantSelected(true)
    }
  }, [productQuantity])

  useEffect(() => {
    if (isMandatoryVariantSelected) {
      setShouldRenderVariantMessage(false)
    }
  }, [isMandatoryVariantSelected])

  const handleAddProductToCart = (item, shouldOpenCart = false, from = origin, index = plpPosition, subOrigin) => {
    if (!isMandatoryVariantSelected && hasValidVariants) {
      setShouldRenderVariantMessage(true)
      return
    }

    handleAddToCart({
      product: item,
      listProduct,
      origin: from,
      subOrigin,
      shouldOpenCart,
      flowType,
      searchState,
      index,
    })
  }

  const handleRemoveProductFromCart = (hit) => handleRemoveOneFromCart(hit, origin, flowType)

  const showStoreSelectorModal = (event) => {
    event.preventDefault()
    setPickUpStoresModalIsOpen(true)
    setPickUpStoresSpinner(true)
  }

  const siteToStoreData = () => {
    const firstSiteToStoreComponent = <SiteToStoreTitle isWalstore={isWalstore} isMobile={isMobile} />
    const secondSiteToStoreComponent = (
      <SecondSiteToStoreComponent
        isWalstore={isWalstore}
        selectedWalstoreStore={selectedWalstoreStore}
        showStoreSelectorModal={showStoreSelectorModal}
        pickupStore={pickupStore}
        pickUpStoresSpinner={pickUpStoresSpinner}
      />
    )

    return { firstSiteToStoreComponent, secondSiteToStoreComponent }
  }

  const renderSiteToStoreComponent = () => {
    const { secondSiteToStoreComponent } = siteToStoreData()
    const defaultProps = {
      firstSiteToStoreComponent: texts.PRODUCT_DETAIL.STORE_SELECTOR_HEAD,
      secondSiteToStoreComponent,
    }
    if (!isWalstore) {
      defaultProps.showStoreSelectorModal = showStoreSelectorModal
      defaultProps.customStyle = { cursor: 'pointer' }
    }
    return <SelectedSiteToStore {...defaultProps} />
  }

  const printRestrictShoppingCartMsg = () =>
    `${texts.PRODUCT_DETAIL.RESTRICT_CART_HEAD} ${texts.PRODUCT_DETAIL.RESTRICT_CART_BOX}`

  const shouldRenderAddButton = isProductAvailableToSell(hit, campaignConfig.blackListProductToSell)

  const renderAddToCartVariantMessage = () => (
    <div className="product-detail-page__alert-container">
      <Alert className="product-detail-page__alert" actionbuttonprops={{}} variant="info">
        <span className="product-detail-page__text-alert">
          {texts.PRODUCT_DETAIL.VARIANT.ALERT_MESSAGE_1}
          <strong>{texts.PRODUCT_DETAIL.VARIANT.ALERT_MESSAGE_2}</strong>
          {texts.PRODUCT_DETAIL.VARIANT.ALERT_MESSAGE_3}
        </span>
      </Alert>
    </div>
  )

  const renderCombinables = (variant) => {
    return (
      <CombinableProducts
        product={hit}
        spaTagMetadata={{ origin, position: plpPosition, query: searchState?.query, flowType }}
      >
        {(childProps) => (
          <FeatureOnModalButton
            variant={variant}
            LDButtonProps={{ variant: 'primary', size: 'medium' }}
            LDSpinnerProps={{ color: 'white' }}
            {...childProps}
          >
            {texts.COMBINABLE_PROMOTION.BUTTON_TEXT}
          </FeatureOnModalButton>
        )}
      </CombinableProducts>
    )
  }

  const productPricesProps = isMobile && {
    tlBciImgClass: 'tlbci-price__img__pdp--mobile',
    tlBciTextClass: 'pdp-mobile-pay-not-tlmc',
    wlmPriceTextClass: 'pdp-mobile-pay-not-tlmc',
    pricePerUmClass: 'price-per-um__pdp price-per-um__pdp--mobile',
  }

  const renderBtn = () => {
    const isNotAvailableToSell = !shouldRenderAddButton || !makePublic
    if (isCombinableProduct && !isNotAvailableToSell) {
      return renderCombinables('product-detail')
    }
    return productQuantity > 0 ? (
      <ButtonGroup
        onAddToCart={(item) => handleAddProductToCart(item, true)}
        onRemoveOneFromCart={() => handleRemoveProductFromCart(hit)}
        hit={hit}
        productQuantity={productQuantity}
        colorUnit={getColorForUnits(maxUnits)}
      />
    ) : (
      <AddToCart disabled={isNotAvailableToSell} onClick={() => handleAddProductToCart(hit, true)} />
    )
  }

  const getExtraPropsForFixedExperiment = () => {
    if (isCombinableProduct) {
      return {
        button: renderCombinables('product-detail-fixed-add-to-cart'),
      }
    }
    return {}
  }

  const openModal = async () => {
    setRetractOpen(true)
  }

  const onClose = () => {
    setRetractOpen(false)
  }

  return (
    <>
      <div className="product-detail-page__container">
        <RctCard
          customClasses="d-flex mb-0 flex-column justify-content-between overflow-hidden"
          customStyles={{ borderRadius: '12px' }}
        >
          <div className="product-detail-card__product-detail-container">
            <div
              className={`product-detail-page__gallery-container ${
                !hit.available ? 'product-detail-page__gallery-container--opaque' : ''
              }`}
            >
              <ImagePreview hit={hit} isMobile={isMobile} />
            </div>
            <div className="product-detail-card__product">
              <div className="product-detail-card__product-info">
                <div className="product-detail-card__brand">
                  <BrandLink brand={brand} facet={isFacetKeysFromPdpEnabled && brandKeyFacet} />
                </div>
                <ProductDetailDisplayName>{displayName}</ProductDetailDisplayName>
                {!isSod && <InlineRating productId={hit.sku} dataBvShow={'rating_summary'}></InlineRating>}

                <div className="product-detail-card__product-detail">
                  {itemNumber && (
                    <span className="product-detail-card__product-item-number">{`item ${itemNumber}`}</span>
                  )}
                </div>
                <BannerLiderPLP_PDP
                  className={'banner-lider-bci-pdp__container'}
                  isMobile={isMobile}
                  liderBCI={bannersPDP}
                  configData={getConfig()}
                />

                <div className="product-detail-card__product-prices">
                  <ProductPrices
                    price={hit.price}
                    discount={discount}
                    {...productPricesProps}
                    enabledBciSod={campaignConfig?.promotions?.enabledBciSod}
                    enabledCatexXxYPack={campaignConfig?.promotions?.enabledCatexXxYPack}
                    soldByWeight={soldByWeight}
                  />
                </div>

                {hasValidVariants && (
                  <ProductVariant
                    variants={hit.variants}
                    updateProduct={updateProduct}
                    product={hit}
                    isMandatoryVariantSelected={isMandatoryVariantSelected}
                    setIsMandatoryVariantSelected={setIsMandatoryVariantSelected}
                  />
                )}

                <div className="product-detail-card__buttons-container">
                  {renderBtn()}

                  {isXxYPromotion && productQuantity > 0 && !isCombinableProduct && (
                    <CompleteProductPack
                      quantity={productQuantity}
                      packPrice={Number(hit.price.packPrice)}
                      packSize={Number(hit.price.packSize)}
                      regularUnitPrice={hit.price.BasePriceSales}
                      parentComponent="pdp"
                    />
                  )}

                  {isMobile && (
                    <>
                      <NewMobileAddToCartButtonPdpFirst
                        productQuantity={productQuantity}
                        hit={hit}
                        discount={discount}
                        onRemoveOneFromCart={() => handleRemoveProductFromCart(hit)}
                        onAddToCartNew={handleAddProductToCart}
                        colorUnit={getColorForUnits(maxUnits)}
                        {...getExtraPropsForFixedExperiment()}
                      />
                      <NewMobileAddToCartButtonPdp
                        productQuantity={productQuantity}
                        hit={hit}
                        discount={discount}
                        makePublic={makePublic}
                        shouldRenderAddButton={shouldRenderAddButton}
                        onClick={() => handleAddProductToCart(hit, true, 'PDPMobile')}
                        {...getExtraPropsForFixedExperiment()}
                      />
                    </>
                  )}
                </div>

                {shouldRenderVariantMessage && renderAddToCartVariantMessage()}

                {maxUnits >= 1 && !restrictShoppingCart && (
                  <p className="alert-sale-units">
                    {textTemplate(texts.PRODUCT_DETAIL.MAX_SALE_PRODUCT_TPL, { maxUnits })}
                  </p>
                )}
                {restrictShoppingCart && productQuantity > 0 && (
                  <p className="alert-sale-units">{printRestrictShoppingCartMsg()}</p>
                )}
              </div>

              {!isSod ? (
                <Fragment>
                  <div className="product-detail-page__separator" />

                  <div
                    data-testid="delivery-label-test-renderer"
                    className="product-detail-card__delivery-button-group"
                  >
                    {!isWalstore && (
                      <ProductSeller
                        isWfsProduct={wfsEligible}
                        sellerName={JSON.parse(isMKP) && winningOffer?.sellerName}
                        facet={isFacetKeysFromPdpEnabled && sellerKeyFacet}
                        setModalIsOpen={setShowWfsDisclaimerModal}
                        customClass={'product-detail-card__delivery-button-group__seller'}
                      />
                    )}

                    {winningOffer?.internationalSeller && <InternationalSeller />}
                    <DeliveryOptionButton
                      deliveryTags={deliveryTags}
                      customClass="product-detail-card__delivery-button"
                    />
                    {showSiteToStoreLabel && renderSiteToStoreComponent()}
                  </div>

                  {rankedOffers?.length > 1 && (
                    <>
                      <div className="product-detail-page__separator" />
                      <BuyboxMoreSellerOptions
                        productId={hit.sku}
                        setModalIsOpen={setShowBuyboxSellerOptionsModal}
                        quantity={rankedOffers.length}
                        price={hit.price.BasePriceSales}
                        flowType={flowType}
                      />
                    </>
                  )}
                </Fragment>
              ) : (
                <Fragment />
              )}

              <div>
                {isSod && <hr className="retract-divisor" />}
                <p>
                  <img
                    className="retract-img"
                    src="https://apps.lider.cl/landing/images/LD_return.svg"
                    alt="LD_return"
                  />
                  <span className="retract-title">Derecho a retracto</span>
                  <Link to="#" onClick={openModal} className="retract-link" data-id="open-modal">
                    Saber más
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <Modal className="retract-modal" isOpen={retractOpen} onClose={onClose} title="Derecho a retracto">
            <RetractModal></RetractModal>
          </Modal>
        </RctCard>

        <WfsDisclaimer
          seller={JSON.parse(isMKP) && winningOffer?.sellerName}
          isOpen={showWfsDisclaimerModal}
          setIsOpen={setShowWfsDisclaimerModal}
        />
        {rankedOffers?.length > 1 && (
          <Suspense fallback="">
            <BuyboxSellerOptions
              isOpen={showBuyboxSellerOptionsModal}
              setIsOpen={setShowBuyboxSellerOptionsModal}
              product={hit}
              onAddToCart={handleAddProductToCart}
              onRemoveFromCart={handleRemoveProductFromCart}
            />
          </Suspense>
        )}
      </div>
      {!isSod && !isWalstore && (
        <PickUpStoresModal
          modalIsOpen={pickUpStoresModalIsOpen}
          closeModalAction={() => {
            setPickUpStoresModalIsOpen(false)
            setPickUpStoresSpinner(false)
          }}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  campaignConfig: state.campaignConfigReducer,
  pickupStore: state.pickupStore,
  restrictShoppingCart: state.shoppingCartReducer.restrictShoppingCart,
  selectedWalstoreStore: state.selectedWalstoreStore,
})

export default connect(mapStateToProps)(ProductDetailCard)

ProductDetailCard.defaultProps = {
  hit: {},
  campaignConfig: { groceryBoxSets: [] },
  restrictShoppingCart: false,
  selectedWalstoreStore: {},
  isWalstore: false,
  origin: ORIGINS.PDP,
  isSod: false,
  flowType: '',
  bannersPDP: {},
  updateProduct: () => {},
}
ProductDetailCard.propTypes = {
  bannersPDP: PropTypes.object,
  hit: PropTypes.object,
  campaignConfig: PropTypes.object,
  pickupStore: PropTypes.object.isRequired,
  restrictShoppingCart: PropTypes.bool,
  selectedWalstoreStore: PropTypes.object,
  isWalstore: PropTypes.bool,
  origin: PropTypes.string,
  isSod: PropTypes.bool,
  flowType: PropTypes.string,
  searchState: PropTypes.object,
  plpPosition: PropTypes.number,
  updateProduct: PropTypes.func,
}
